//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import intro from '@/components/clinic/intro.vue'
import evaluate from '@/components/clinic/evaluate.vue'
import doctorFn from '@/components/clinic/doctorFn.vue'
import anger from '@/assets/icons/anger.png'
import oasis from '../../lib/api.oasis'
import apis from '../../lib/api.new'
import { doctorProf } from '../../lib/correspondence'
import native from '../../lib/native'
import * as util from '@/lib/util'
import doctorImg from '@/assets/img/doctor0.jpg'
export default {
  // props: ['doctor'],
  data () {
    return {
      titleName:'医生工作室',
      isCollect:false,
      white:true,
      bgWhiteMargin: {
        marginTop: '2rem',
        marginLeft: 'calc( (100% - 6.98rem) / 2 )'
      },
      doctorImg: doctorImg,
      doctorImgMargin: {
        marginTop: '60px',
        left: 'calc( (100% - 1.66rem) / 2 )'
      },
      doctor: { // 医生的信息
        name: '',
        professional: '',
        hospital: '',
        url:'',
        effect:'',
        attitude:'',
        workyear:'',
        doctoraccountid:''
      },
      // 医生开通的功能
      // doctorFnDataBox: [],
      doctorFnData: [],
      // 擅长、简介
      gootAt: {
        title: '医师擅长',
        content: ''
      },
      introInfo: {
        title: '医师简介',
        content: ''
      },
      anger: anger,
      // 评论
      evaluateDatas: [],
      isCollectSign:null
    }
  },
  components: {
    intro,
    evaluate,
    doctorFn
  },
  // beforeRouteEnter (to, from, next) {
  //      console.log(to.meta.title,'---------from-path----------------')
  //       if(to.meta.title==='医生详情'){
  //           native.setWebview(JSON.stringify({
  //               navigation:'0',
  //               refresh:'1'
  //           }));
  //       }
  //       next()

  // },
  beforeRouteLeave (to, from, next) {
      console.log(from.meta.title,'我出来了')
      console.log(to,'to')
      if(from.meta.title==='附近医院详情'){
          native.setWebview(JSON.stringify({
              navigation:1,
              refresh:1
          }));
      }
      next()
  },
  created(){
  },
  methods: {
    goCollect(){
      if(!util.checkLogin()){
        if(util.getBrowser().isapp){
          native.oasislogin()
        }else{  
          this.$router.push({
            path: `/login`,
            query:{
              url:encodeURIComponent(location.href),
              replace:true
            }
          })
        }
      }else{
        if(this.isCollect){
          this.cancelCollect()//取消关注
        }else{
          this.checkCollect()//关注
        }
      }
    },
    cancelCollect(){
      var info = {
        homeCareType:"DOCTOR",   // DOCTOR医生/NURSE护士
        customerAccountId:util.getCookie('customerid'),     // 客户端用户编号    
        doctorId:this.$route.params.id,
      }
      apis.cancelCollectHomecare(info).then(res=>{
        if(res.status==0){
          this.$vux.toast.text('取消关注成功')
          this.isCollect =  false 
        }
      }).catch(err=>{
        console.log(err,'errCatch');
      })
    },
    checkCollect(){
      var info = {
        homeCareType:"DOCTOR",   // DOCTOR医生/NURSE护士
        customerAccountId:util.getCookie('customerid'),     // 客户端用户编号    
        doctorId:this.$route.params.id,
      }
      apis.collectHomecare(info).then(res=>{
        if(res.status==0){
          this.$vux.toast.text('关注成功，您可在我的-我的医护里查看')
          this.isCollect =  true 
        }
      }).catch(err=>{
        console.log(err,'errCatch');
      })
    },
    evaluateBoxShow(evaluateDatas){
      // console.log(evaluateDatas,'====')
      if(evaluateDatas&&evaluateDatas.length>0){
        return true
      }else{
        return false
      }
    },
    positionImg(){
        let classNameIosx='positionImgx'
        let classNameAnroid='positionImgs'
        let classNameIos='positionImg'
        if(util.getBrowser().isios){
            if (screen.height == 812 && screen.width == 375){
                return classNameIosx
            }else{
                return classNameIos
            }
        }else if(util.getBrowser().isandroid){
            return classNameAnroid
        }else{
            return classNameAnroid
        }
    },
    headTitle(){
        if(util.getBrowser().isapp){
          return true
        }else{
          return false
        }
    },
    goBackLeft(){
			native.oasisfinish()
      // native.finishWebViewNav(JSON.stringify({
      //     status:'1'
      // }));
    },
    goShare(name,url,content){
      var IntroductionOne=content.replace(/<[^>]*>|/g,"");
      var IntroductionTwo=IntroductionOne.replace(/[\r\n\t]/g,"");
      var IntroductionThree=IntroductionTwo.replace(/\ +/g,"")
      var json={
          flag:'1',
          shareurl:location.href.replace('http://', 'https://'),
          sharetitle:name,
          sharecontent:IntroductionThree.substring(0,50)||'暂无内容'
      }
      if(url){
        var shareimage=url
        json.shareimage=shareimage.replace('http://', 'https://') 
      }else{
        json.shareimage='https://m.oasisapp.cn/img/logo210.png'
      }
      console.log(JSON.stringify(json),'JSON.stringify(json)')
      native.navishare(JSON.stringify(json));
    },
    // 请求医生基本信息
    doctorDetail () {
      var infos = {
        "customerid":util.getCookie('customerid'),
        "latitude":"0.000000",
        "longitude":"0.000000",
        "doctorid":this.$route.params.id
      }
      oasis.postDoctorDetail(infos).then(response => {
        let data = response.data
        console.log(data,'-----datas--')
        this.doctor.doctoraccountid = data.accountid
        this.isCollectSign = data.isFollow //处理关注字段
        this.isCollect = data.isFollow == 1 ? true : false
        this.doctor.url=data.head
        this.doctor.effect = data.medeffect
        this.doctor.attitude = data.attitudetype
        this.doctor.name = data.name
        this.doctor.workyear = data.workdate
        this.doctor.professional = doctorProf[data.prof]
        this.doctor.hospital = data.hospital + ' (' + data.deptname + ')'
        this.titleName = `${data.name}工作室`
      }).catch(error => {
        console.log(error)
      })
    },
    // 医生详情页的擅长、简介 li
    doctorIntroduce () {
      // var infos = "?doctorid=1111";
      let info =  {doctorid:this.$route.params.id}
      oasis.getDoctorIntroduce(info).then(response => {
        // console.log(response,'respose')
        this.gootAt.content = response.data.expertise
        this.introInfo.content = response.data.intro
      }).catch(error => {
        console.log(error)
      })
    },
    // 医生详情页的医生功能的接口 li
    doctorsServices () {
      // console.log(2);
      let that = this
      var infos = {doctorid:this.$route.params.id}
      oasis.postDoctorsServices(infos).then(response => {
        console.log(response.datalist,'------------------8-')
        let dl = response.datalist
        let tempArr = []
        dl.forEach( function (item, index, arr) {
          if(item.menuname=='门诊预约'){
            item.isuse = 'N'
          }
          let obj = {}
          if (item.isuse === 'N') {
            obj.useable = false
          } else {
            obj.useable = true
          }
          obj.text = item.menuname
          obj.isuse=item.isuse
          tempArr.push(obj)
        })
        this.doctorFnData = tempArr
        console.log(this.doctorFnData,'this.doctorFnData')
      }).catch(error => {
        console.log(error)
      })
    },
    // 医生详情页的评价的接口 li
    doctorAssess () {
      var infos = {
        "stafftype":"1005",
        "staffid":this.$route.params.id,
        "pagenum":1,
        "pagesize":"10"
      }
      oasis.postDoctorAssess(infos).then(response => {
        // console.log(response,'999999999999999')
        this.evaluateDatas = response.comments 
      }).catch(error => {
        console.log(error)
      })
    },
    gotolink (text,isuse) {
      var doctorid = this.$route.params.id
      var phone=util.getCookie('mobile')
      var accountid=util.getCookie('accountid')
      var doctorName=this.doctor.name
      if(isuse=='N'){
        this.$vux.toast.text('暂未开通')
      }else{
        if(!util.checkLogin()){
          if(util.getBrowser().isapp){
            native.oasislogin()
          }else{  
            this.$router.push({
              path: `/login`,
              query:{
                url:encodeURIComponent(location.href),
                replace:true
              }
            })
          }
        }else{
          if(text=='私人医生'){
            var url = location.origin.indexOf("test")!=-1 ? `https://doctortest.oasiscare.cn/personaldoctor/html/doctorDetail.html?doctorid=${doctorid}&accountid=${accountid}&mobile=${phone}`
                                                          : `https://doctor.oasiscare.cn/personaldoctor/html/doctorDetail.html?doctorid=${doctorid}&accountid=${accountid}&mobile=${phone}`                                      
            native.openwebview(JSON.stringify({
              linkurl:url,
              ifNavigation:'1'
            }));                                              
          }else if (text=='门诊预约') {
            return
            native.clickMedicalCareDetail(JSON.stringify({
              doctorid:doctorid,
              kind:'4'
            }));
          }else if (text=='电话咨询') {
            if(util.getBrowser().isapp){
              var infos={
                accountid:this.doctor.doctoraccountid,//传医生accountid
                stafftype:'1005'
              }
              oasis.phoneConsole(infos).then(response => {
                // console.log(response,'电话咨询')
                if(response.code=='1'||response.code=='2'){
                  this.$vux.toast.text(response.msg)
                }else{
                  native.commitorderdoctor(JSON.stringify({
                    doctoraccountid:response.doctoraccountid,
                    doctorname:response.doctorname,
                    doctorid:response.doctorid
                  }));
                }
              }).catch(error => {
                console.log(error)
              })
            }else{  
              util.downloadUser()
            }
          }else{
            this.$vux.toast.text('暂未开通')
          }
        }
      }
    },
    handleScroll () {
      if(util.getBrowser().isapp){
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // console.log(scrollTop)
        let swipers=document.getElementsByClassName('ddHeader')
        let swipersHeight=swipers[0].clientHeight
        //  console.log(swipersHeight,'aHeight')
        if(scrollTop>10&&scrollTop<swipersHeight){
          this.white=false;
          let newOpacity=scrollTop/swipersHeight;
          let newBoxopacity=(1-newOpacity)  
          this.$refs.domHome.style.color='black'; 
          this.$refs.positionImg.style.background='#fff'
          this.$refs.positionImg.style.opacity=newOpacity;
          this.$refs.collectBox.style.opacity =  this.$refs.shareBox.style.opacity =  this.$refs.returnBox.style.opacity = newBoxopacity ;
        }else if(scrollTop>swipersHeight){
          this.white=false;
          this.$refs.domHome.style.color='black';
          this.$refs.positionImg.style.background='#fff'
          this.$refs.positionImg.style.opacity=1
          this.$refs.collectBox.style.opacity = this.$refs.returnBox.style.opacity = this.$refs.shareBox.style.opacity = 1 ;
          this.$refs.collectBox.style.background = this.$refs.returnBox.style.background =  this.$refs.shareBox.style.background = '#fff' ;
          this.$refs.collectBox.style.boxShadow = this.$refs.returnBox.style.boxShadow = this.$refs.shareBox.style.boxShadow = '0px 0px 0px 0px #fff';
        }else{
          this.white=true;
          this.$refs.positionImg.style.background=''
          this.$refs.domHome.style.color='white';
          this.$refs.positionImg.style.opacity=''
          this.$refs.collectBox.style.background = this.$refs.returnBox.style.background =  this.$refs.shareBox.style.background= 'rgba(0,0,0,0.3)' ;
        }
      }  
    },
    // 为详情页写的硬编码
    corresRouter: function () {
      // console.log(this.$router)
      // if () {

      // }
      let app = document.getElementById('app')
      app.classList.add('postitionStatic')
    }
  },
  mounted () {
    // this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
    this.doctorDetail()
    this.doctorIntroduce()
    this.doctorsServices()
    this.doctorAssess()
    this.corresRouter()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)

  },
}



// WEBPACK FOOTER //
// ./src/views/clinic/doctorDetail.vue